import(/* webpackMode: "eager" */ "/var/www/businessstorepro/app/node_modules/next/dist/client/link.js");
